import React from 'react'
import { BASE_URL, SUB_URL_KCA } from '../BaseUrl';
import axios from 'axios';

const KCA_Service = {

    getKCA_DailyReport: async () => {
        try {

            const response = await axios.get(
                `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_KCA.get_kca_daily_report}`);
            return response.data;
        } catch (error) {
            console.error("Error in BinOutward:", error);
        }
    },

}

export default KCA_Service